import { useUpdateOrgMemoTrackingEnabled } from "@/apiQueries/useUpdateOrgMemoTrackingEnabled";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardWithToggler } from "./CardWithToggler";

export const SettingsEnableMemoTracking = () => {
  const { organization } = useRedux("organization");
  const { isChecked, isPending, error, handleToggleChange } = useSettingsToggle({
    currentValue: Boolean(organization.data.isMemoTracingEnabled),
    useUpdateMutation: useUpdateOrgMemoTrackingEnabled,
    getNextValue: (current) => !current,
  });

  return (
    <CardWithToggler
      toggleId="memo-tracing-toggle"
      label="Enable memo tracing"
      note={
        <>
          <span>
            When enabled, payments will include an organization-specific memo if the receiver's
            wallet doesn't have an associated memo. This memo is derived from your server URL and
            will update if the URL changes (e.g. <code>sdp-100680ad546c</code>).
          </span>
          <span className="Note__emphasis">
            Note: Memo tracing is automatically disabled for Embedded Wallets due to memos not being
            supported.
          </span>
        </>
      }
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    />
  );
};
